export function redirectWithFlash(router, path, flash) {
  try {
    sessionStorage.setItem("flash", JSON.stringify(flash));
  } catch (e) {
    // ignore
  }
  const query = {
    flashType: flash.type,
    flashTitle: flash.title || "",
    flashMsg: flash.msg,
  };
  router.push({ path, query });
}

export function showFlashFromRoute(vm, refName = "alert") {
  try {
    const q = vm.$route.query;
    if (q && q.flashType && q.flashMsg) {
      if (vm.$refs[refName] && vm.$refs[refName].showAlert) {
        vm.$refs[refName].showAlert(
          q.flashType,
          q.flashMsg,
          q.flashTitle || "",
          {
            iconSize: 35,
            iconType: "solid",
            position: "top right",
            closeIn: 5000,
          }
        );
      }
      const rest = Object.assign({}, q);
      delete rest.flashType;
      delete rest.flashTitle;
      delete rest.flashMsg;
      vm.$router.replace({ path: vm.$route.path, query: rest });
      sessionStorage.removeItem('flash');
      return;
    }
  } catch (e) {
    // ignore
  }

  try {
    const raw = sessionStorage.getItem("flash");
    if (raw) {
      const f = JSON.parse(raw);
      if (
        f &&
        f.type &&
        f.msg &&
        vm.$refs[refName] &&
        vm.$refs[refName].showAlert
      ) {
        vm.$refs[refName].showAlert(f.type, f.msg, f.title || "", {
          iconSize: 35,
          iconType: "solid",
          position: "top right",
          closeIn: 5000,
        });
      }
      sessionStorage.removeItem("flash");
    }
  } catch (e) {
    // ignore
  }
}
